<template>
  <v-menu v-model="testMenu" :close-on-content-click="false" :close-on-click="false" offset-y right top :nudge-width="500" max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn outline v-on="on" color="info" :disabled="checkBtnDisabled" class="checkBtn">
        <v-icon>build</v-icon>{{$t('Button.Check')}}
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <div>Input Formula : <span class="formula-text">{{Formula}}</span></div>
        <div v-if="variable && variable.length">Please enter variable test value and unit.</div>
        <v-form v-for="(item,index) in variable" :key="index">
          <v-layout row>
            <v-flex xs6 pr-1>
              <v-text-field :label="item.name + ' value'" v-model="item.value" :rules="[rules.required, rules.numeric]">
              </v-text-field>
            </v-flex>
            <v-flex xs6 pl-1>
              <v-autocomplete :label="item.name + ' unit'" v-model="item.unit" :items="allUnits" item-text="Name"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-form>
        <v-alert :value="showAlert" type="warning">Testing value and unit could be empty.Please input the value and unit.</v-alert>
        <v-card v-if="showResult" :class="valid?'background-true':'background-false'">
          <v-card-title primary-title>
            <div>
              <h3>Result: {{ result }}</h3>
              <div>{{ message }}</div>
            </div>
          </v-card-title>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small dark color="add" @click="checkFormula()">
          <v-icon>build</v-icon>{{$t('Button.Check')}}
        </v-btn>
        <v-btn small outline color="secondary" @click="cancel()">{{$t('Button.Cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    SPLIT_REGEX,
    NUMBER_REGEX,
    OPERATOR_REGEX,
    PARAMETER_REGEX,
  } from '@/helpers/regex'
  import { AmmoniaLookupTable } from '@/components/mixins/GuidelinesManageUtil'
  const unit = createNamespacedHelpers('unit')
  const guidelines = createNamespacedHelpers('guidelines')

  export default {
    props: {
      Formula: {
        type: String,
        default: '',
      },
      ValueType: {
        type: String,
        default: '',
      },
      dialog: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        testMenu: false,
        showResult: false,
        panel: [true],
        result: '',
        message: '',
        valid: true,
        showAlert: false,
        rules: {
          required: (v) => !!v || 'Required.',
          numeric: (v) => {
            const regular = /^(-)?\d+(\.\d+)?$/
            return regular.test(v) || 'The data entered must be numeric.'
          },
        },
      }
    },
    computed: {
      ...unit.mapGetters(['allUnits']),
      formulas() {
        if (!this.Formula) return []
        let arr = this.Formula.match(SPLIT_REGEX)
        if (arr != null) {
          let list = arr.map(x => this.textType(x))
          return list
        }
        return []
      },
      variable() {
        let list = []
        this.formulas.forEach(x => {
          if (x.type == 'parameter') {
            list.push(x.value)
          }
        })
        list = Array.from(new Set(list))
        let newList = []
        list.forEach(x => {
          newList.push({
            name: x,
            value: null,
            unit: null,
          })
        })
        return newList
      },
      checkBtnDisabled() {
        if (this.ValueType && this.ValueType != AmmoniaLookupTable && this.Formula) {
          return false
        } else return true
      },
    },
    watch: {
      dialog() {
        if (this.dialog == false) {
          this.cancel()
        }
      },
    },
    methods: {
      ...guidelines.mapActions(['StandardValueCheck']),
      textType(item) {
        let result = {
          type: 'normal',
          value: item,
        }
        if (NUMBER_REGEX.test(item)) {
          result.type = 'number'
        } else if (PARAMETER_REGEX.test(item)) {
          result.type = 'parameter'
        } else if (OPERATOR_REGEX.test(item)) {
          result.type = 'operator'
        } else {
          result.type = 'normal'
        }
        return result
      },
      cancel() {
        this.testMenu = false
        this.showResult = false
        this.showAlert = false
        this.variable.forEach(x => {
          x.value ? x.value = '' : ''
          x.unit ? x.unit = '' : ''
        })
      },
      checkFormula() {
        let Cofactors = []
        this.variable.forEach(x => {
          let name = x.name.substring(1, x.name.length - 1)
          let delimiterIndex = name.indexOf('|')
          if (delimiterIndex > -1) {
            name = name.substring(0, delimiterIndex)
          }
          Cofactors.push({
            CofactorName: name,
            Value: x.value,
            Unit: x.unit,
          })
        })
        let Empty = !Cofactors.every(x => x.Value && x.Unit)
        if (Cofactors && Empty) {
          this.showAlert = true
        } else {
          this.showAlert = false
          let options = {
            data: {
              StandardValue: this.Formula,
              Cofactors: Cofactors,
              ValueType: this.ValueType,
            },
            successCb: (res) => {
              this.showResult = true
              if (this.ValueType == 'range') {
                this.valid = res.data == true ? true : false
                let reply = res.data == true ? 'Within guideline' : 'Exceed guideline'
                this.result = reply
                this.message = ''
              } else {
                this.valid = true
                this.result = res.data
                this.message = 'Input formula is valid.'
              }
            },
            failedCb: (error) => {
              this.showResult = true
              this.valid = false
              this.result = error.response.data.Message
              this.message = error.response.data.ExceptionMessage
            },
          }
          this.StandardValueCheck(options)
        }
      },
    },
  }
</script>

<style scoped>
  .formula-text {
    color: rgba(0, 0, 0, .68)
  }

  .background-true {
    background-color: #4CAF507f !important;
  }

  .background-false {
    background-color: #FFC1077f !important;
  }

  .checkBtn {
    margin-left: 56px;
  }
</style>